import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Top from '@/components/Top'
import Calte from '@/components/Calte'
import CalteFromOtherPage from '@/components/CalteFromOtherPage'
import Issue from '@/components/Issue'
import IssueEdit from '@/components/IssueEdit'
import IssueDownload from '@/components/IssueDownload'
import Register from '@/components/Register'
import Result from '@/components/Result'
import State from '@/components/State'
import StateLine from '@/components/StateLine'
import Stock from '@/components/Stock'
import Usermente from '@/components/Usermente'
import UsermenteEdit from '@/components/UsermenteEdit'
import Linemente from '@/components/Linemente'
import LinementeEdit from '@/components/LinementeEdit'
import Processmente from '@/components/Processmente'
import ProcessmenteEdit from '@/components/ProcessmenteEdit'
import Machinemente from '@/components/Machinemente'
import MachinementeEdit from '@/components/MachinementeEdit'
import Codemente from '@/components/Codemente'
import CodementeEdit from '@/components/CodementeEdit'
import Partsmente from '@/components/Partsmente'
import PartsmenteEdit from '@/components/PartsmenteEdit'
import Toolmente from '@/components/Toolmente'
import ToolmenteEdit from '@/components/ToolmenteEdit'
import Lineformationmente from '@/components/Lineformationmente'
import LineformationmenteEdit from '@/components/LineformationmenteEdit'
import Tracemente from '@/components/Tracemente'
import TracementeEdit from '@/components/TracementeEdit'
import NgRate from '@/components/NgRate'
import Schedule from '@/components/Schedule'
import ScheduleEdit from '@/components/ScheduleEdit'

Vue.use(Router)

export default new Router({
  routes: [{
    path: '/',
    name: 'Login',
    component: Login,
    meta: {
      layout: 'login'
    }
  },
  {
    path: '/top',
    name: 'top',
    component: Top
  },
  {
    path: '/calte',
    name: 'calte',
    component: Calte
  },
  {
    path: '/calteFromOtherPage',
    name: 'calteFromOtherPage',
    component: CalteFromOtherPage
  },
  {
    path: '/issue',
    name: 'issue',
    component: Issue
  },
  {
    path: '/issueDownload',
    name: 'issueDownload',
    component: IssueDownload
  },
  {
    path: '/issueEdit',
    name: 'issueEdit',
    component: IssueEdit
  },
  {
    path: '/register',
    name: 'registr',
    component: Register
  },
  {
    path: '/result',
    name: 'result',
    component: Result
  },
  {
    path: '/state',
    name: 'state',
    component: State
  },
  {
    path: '/stateline',
    name: 'stateline',
    component: StateLine
  },
  {
    path: '/stock',
    name: 'stock',
    component: Stock
  },
  {
    path: '/usermente',
    name: 'usermente',
    component: Usermente
  },
  {
    path: '/usermenteEdit',
    name: 'usermenteEdit',
    component: UsermenteEdit
  },
  {
    path: '/linemente',
    name: 'linemente',
    component: Linemente
  },
  {
    path: '/linementeEdit',
    name: 'linementeEdit',
    component: LinementeEdit
  },
  {
    path: '/processmente',
    name: 'processmente',
    component: Processmente
  },
  {
    path: '/processmenteEdit',
    name: 'processmenteEdit',
    component: ProcessmenteEdit
  },
  {
    path: '/machinemente',
    name: 'machinemente',
    component: Machinemente
  },
  {
    path: '/machinementeEdit',
    name: 'machinementeEdit',
    component: MachinementeEdit
  },
  {
    path: '/codemente',
    name: 'codemente',
    component: Codemente
  },
  {
    path: '/codementeEdit',
    name: 'codementeEdit',
    component: CodementeEdit
  },
  {
    path: '/partsmente',
    name: 'partsmente',
    component: Partsmente
  },
  {
    path: '/partsmenteEdit',
    name: 'partsmenteEdit',
    component: PartsmenteEdit
  },
  {
    path: '/toolmente',
    name: 'toolmente',
    component: Toolmente
  },
  {
    path: '/toolmenteEdit',
    name: 'toolmenteEdit',
    component: ToolmenteEdit
  },
  {
    path: '/lineformationmente',
    name: 'lineformationmente',
    component: Lineformationmente
  },
  {
    path: '/lineformationmenteEdit',
    name: 'lineformationmenteEdit',
    component: LineformationmenteEdit
  },
  {
    path: '/tracemente',
    name: 'tracemente',
    component: Tracemente
  },
  {
    path: '/tracementeEdit',
    name: 'tracementeEdit',
    component: TracementeEdit
  },
  {
    path: '/ngRate',
    name: 'ngRate',
    component: NgRate
  },
  {
    path: '/schedule',
    name: 'schedule',
    component: Schedule
  },
  {
    path: '/scheduleEdit',
    name: 'scheduleEdit',
    component: ScheduleEdit
  }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js